import React from 'react'
import { Updater, any, async, fromJSX, Widget } from 'widgets-for-react'
import { List } from 'immutable'
import {
  LocationExpandableBlockState,
  Location,
  locationExpandableBlockStateUpdaters,
} from './locationExpandableBlockState'
import { LocationExpandableBlockLayout } from './locationExpandableBlockLayout'
import { parsePhoneNumber } from '../../../../../utils/phoneNumber'
import { LocationExpandableBlock } from '../../blocksState'

export const locationExpandableBlockWidget = (
  block: LocationExpandableBlock
): Widget<Updater<LocationExpandableBlockState>> => {
  const locations = block.locationExpandableBlockState.kind == "loaded"
    ? block.locationExpandableBlockState.value.toArray()
    : []
  return any<Updater<LocationExpandableBlockState>>([
    async<List<Location>>(block.locationExpandableBlockState),
    fromJSX((setState) => (
      <LocationExpandableBlockLayout
        index={block.index}
        title={block.title}
        intro={block.intro}
        locations={locations
          .map((location) => ({
            title: location.title,
            url: `/contact${location.slug}`,
            expanded: location.expanded,
            clinics: location.clinics.map((clinic) => ({
              kind: clinic.kind,
              title: clinic.title,
              phoneNumber: (clinic.phoneNumber ?? []).map(parsePhoneNumber).filter(x=>x.formatted && x.uri),
              openingTimes: clinic.openingTimes,
              visitingTimes: clinic.visitingTimes,
              route: clinic.route,
            })),
          }))
        }
        expand={(i: number) => setState(locationExpandableBlockStateUpdaters.expandedUpdater(i))}
      />
    ))
  ])
}